(function () {
  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }

  // Variant selection -> update hidden id + button state
  document.querySelectorAll('.product-form').forEach(function (form) {
    var optionSelects = form.querySelectorAll('.product-form__option select');
    var variantSelect = form.querySelector('.product-form__variants');
    if (!variantSelect || !optionSelects.length) return;
    function sync() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; }).join(' / ');
      Array.prototype.forEach.call(variantSelect.options, function (opt) {
        if (opt.text === chosen) variantSelect.value = opt.value;
      });
    }
    optionSelects.forEach(function (s) { s.addEventListener('change', sync); });
    sync();
  });
})();
